export const SUPPORT_EMAIL = 'hello@nextainsight.com';
